import React from 'react';

export interface RoundBadgeProps {
  content: React.ReactNode;
}

export const RoundBadge = ({ content }: RoundBadgeProps) => {
  return (
    <div className="flex justify-center items-center rounded-full w-[20px] h-[20px] bg-neutral-200 text-neutral-500 text-xs">
      {content}
    </div>
  );
};
